import * as React from "react";

import { cn } from "@/utils/lib";

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

const Input = ({
  ref,
  className,
  type,
  ...props
}: InputProps & {
  ref?: React.Ref<HTMLInputElement>;
}) => {
  return (
    <input
      type={type}
      className={cn(
        `
          flex
          w-full
          rounded-full border border-border-light
          bg-input
          px-3 py-2 text-sm text-muted-foreground ring-offset-background file:border-0 file:bg-transparent
          file:text-sm file:font-medium placeholder:text-muted focus:border-foreground
          focus-visible:outline-hidden
          disabled:cursor-not-allowed disabled:opacity-50
        `,
        className,
      )}
      ref={ref}
      {...props}
    />
  );
};
Input.displayName = "Input";

const InputWithIcon = ({
  ref,
  icon,
  className,
  ...props
}: InputProps & {
  icon: React.ReactNode;
  ref?: React.Ref<HTMLInputElement>;
}) => {
  return (
    <div className="relative flex items-center">
      <div className="pointer-events-none absolute left-3">{icon}</div>
      <Input className={cn("pl-9", className)} ref={ref} {...props} />
    </div>
  );
};
InputWithIcon.displayName = "InputWithIcon";

export { Input, InputWithIcon };
